export default "/img/VN.3e123f3632b8144a940e87162370814b.png";